<div class="header_search header_search_mobile">
  <div class="title-page">
    <h3>Novo Vínculo FPE</h3>
  </div>
  <div class="content_search">
    <div class="new-demand">
      <button type="button" class="btn btn-white btn" (click)="cancelar()">Voltar</button>
    </div>
  </div>
</div>

<div>
  <div class="form_search">
    <div class="m-b">
      <div class="form-group form-filter">
        <h3>Filtros</h3>
        <div class="col-8 d-flex justify-content-end">
          <button class="btn-filters" type="button" (click)="cleanForm()">
            <img src="assets/images/svgs/Limpar_filtros.svg">
            <span>Limpar Filtros</span>
          </button>
        </div>
      </div>
    </div>
    <form [formGroup]="form">
      <div class="form-group row">
        <div class="col-12 col-sm-6 m-b">
          <label class="col-sm-12 pb-1">Projeto LOA</label>
          <ng-select id="projeto_loa" class="ng-select-alternative" (change)="initFilters(true)" [items]="filters?.projetos_loa" bindLabel="label" bindValue="id" placeholder="Selecione o projeto" formControlName="projeto_loa">
          </ng-select>
          <app-field-message [field]="fieldMessageRequired('projeto_loa')" [erros]="fieldErros('projeto_loa')"></app-field-message>
        </div>

        <div class="col-12 col-sm-6 m-b">
          <label class="col-sm-12 pb-1">Subprojeto LOA</label>
          <ng-select id="subprojeto" class="ng-select-alternative" [multiple]="true" [items]="filters?.subprojeto" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="subprojeto">
          </ng-select>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-12 col-sm-6 m-b">
          <label class="col-sm-12 pb-1">Recurso</label>
          <ng-select id="recurso" class="ng-select-alternative" [multiple]="true" [items]="filters?.recurso" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="recurso">
          </ng-select>
        </div>

        <div class="col-12 col-sm-6 m-b">
          <label class="col-sm-12 pb-1">Natureza da Despesa</label>
          <ng-select id="natureza_despesa" class="ng-select-alternative" [multiple]="true" [items]="filters?.natureza_despesa" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="natureza_despesa">
          </ng-select>
        </div>

        <div class="col-12 btn-search m-b">
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary btn" type="button" (click)="pesquisar()">Pesquisar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="hr-line-dashed"></div>

<div class="system-table table-container table-form">
  <div class="system-table-conteiner system-table-form-conteiner">
    <table>
      <thead>
        <tr>
          <th *ngIf="list?.length">
            <div class="form-group row">
              <div class="col-sm-12">
                <div class="switch">
                  <div class="onoffswitch">
                    <input type="checkbox" (change)="selectAll()" [checked]="checked" class="onoffswitch-checkbox" id="checked">
                    <label class="onoffswitch-label" for="checked">
                      <span class="onoffswitch-inner switchCheck"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </th>
          <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'projeto_loa', title:'Projeto LOA' } }">
          </ng-container>
          <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'subprojeto', title:'Subprojeto LOA' } }">
          </ng-container>
          <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'recurso', title:'Recurso' } }">
          </ng-container>
          <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'grupo_natureza_despesa', title:'Natureza da Despesa' } }">
          </ng-container>
          <th class="text-center">Dotação c/ Alteração </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="filteredData?.length">
          <tr *ngFor="let item of filteredData; let i = index">
            <td class="title">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="switch">
                    <div class="onoffswitch">
                      <input type="checkbox" (change)="item.checked = !item?.checked;" [checked]="item?.checked" class="onoffswitch-checkbox" id="{{i}}">
                      <label class="onoffswitch-label" for="{{i}}">
                        <span class="onoffswitch-inner switchCheck"></span>
                        <span class="onoffswitch-switch"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                id: item?.projeto_loa,
                label: item?.fpe_projeto_loa?.nome_extenso,
                showProjName: item?.showProjName
                } }">
              </ng-container>
            </td>
            <td>
              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                id: formatSubprojeto(item),
                label: item?.fpeAcao?.nome_extenso,
                showProjName: item?.showProjName
                } }">
              </ng-container>
            </td>
            <td>
              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                id: item?.recurso,
                label: item?.execucao_orcamentaria_recursos?.nome_reduzido,
                showProjName: item?.showProjName
                } }">
              </ng-container>
            </td>
            <td>
              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                id: item?.grupo_natureza_despesa,
                label: item?.execucao_orcamentaria_natureza_despesa?.nome_reduzido,
                showProjName: item?.showProjName
                } }">
              </ng-container>
            </td>
            <td class="text-center">{{ item?.dotacao | number:'1.2-2' }}</td>
          </tr>
        </ng-container>
        <tr *ngIf="!list?.length" class="border-b-radius">
          <td colspan="5" class="text-center">Realize uma pesquisa.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="list?.length">
  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-primary btn" type="button" (click)="salvar()">Salvar</button>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>


<ng-template #tdLabel let-data>
  <div class="resp-content" title="{{data.label}}">
    <div>{{ data.id }}
      <span class="icone-info" *ngIf="data.label" (click)="data.showProjName = !data?.showProjName">
        <i class="pl-1 fa fas fa-chevron-circle-down"></i>
      </span>
    </div>
    <div class="resp-info" *ngIf="data?.showProjName">
      <div class="manager-info">
        <div>{{ data.label }}</div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #columnOrder let-data>
  <th>
    <div class="columnOrder">
      <b>{{data.title}}</b>
      <button class="btn font-icon orderIcon"  type="button" (click)="orderData(data.id)"> swap_vert </button>
    </div>
  </th>
</ng-template>